export class TopMenuData {
  public id: number
  public name: string
  public key: string
  public value: number
  public color: string
  constructor(
    id: number,
    name: string,
    key: string,
    value: number,
    color: string
  ) {
    this.id = id
    this.name = name
    this.key = key
    this.value = value
    this.color = color
  }
}

export class ChartData {
  public period: string
  public value: number
  constructor(period: string, value: number) {
    this.period = period
    this.value = value
  }
}

export class TopVisitData {
  public id: number
  public title: string
  public total_user: string
  public total_visit: string
  public created_date: string
  public file_code: string
  constructor(
    id: number,
    title: string,
    total_user: string,
    total_visit: string,
    created_date: string,
    file_code: string
  ) {
    this.id = id
    this.title = title
    this.total_user = total_user
    this.total_visit = total_visit
    this.created_date = created_date
    this.file_code = file_code
  }
}

export class ExportData {
  public link: string
  constructor(link: string) {
    this.link = link
  }
}

export class Export {
  public success: boolean
  public message: string
  public data?: ExportData

  constructor(success: boolean, message: string, data?: ExportData) {
    this.success = success
    this.message = message
    this.data = data
  }
}

export class AccessRateChartsData {
  public month: number
  public percentage: number
  public totalUserAccess: number
  public totalUserVisit: number
  constructor(
    month: number,
    percentage: number,
    totalUserAccess: number,
    totalUserVisit: number
  ) {
    this.month = month
    this.percentage = percentage
    this.totalUserAccess = totalUserAccess
    this.totalUserVisit = totalUserVisit
  }
}

export class BulletinReport {
  public success: boolean
  public message: string
  public topMenu?: TopMenuData[]
  public chart?: ChartData[]
  public accessRateCharts?: AccessRateChartsData[]
  public topVisit?: TopVisitData[]
  constructor(
    success: boolean,
    message: string,
    topMenu?: TopMenuData[],
    chart?: ChartData[],
    accessRateCharts?: AccessRateChartsData[],
    topVisit?: TopVisitData[]
  ) {
    this.success = success
    this.message = message
    this.topMenu = topMenu
    this.chart = chart
    this.accessRateCharts = accessRateCharts
    this.topVisit = topVisit
  }
}
